///include /assets/js/app/p/direct-debit-capture.js

class DirectDebitCaptureGoCardless extends PaymentInfoCapturePGDriver {
    static get type() {
        return "gocardless"
    }
    get canCapture() {
        return true
    }
    /**
     *
     * @param {?string} return_url
     * @param {boolean} [from_vue]
     */
    init(return_url = null, from_vue = true) {
    }
    /**
     * @param {HTMLFormElement} pf
     */
    async initForm(pf) {
    }
    /**
     * @param {?string} currency
     * @returns {Promise<boolean>}
     */
    async startAdd(currency) {
        location.href = "/add-payment-item-link?" + $.param({
            currency: currency,
            return_url: "/checkout",
            type: "debit",
        })
        return false
    }
}
PaymentInfoCapture.drivers.debit.addDriver(DirectDebitCaptureGoCardless)